/**
 * 根路径
 */
export const C_URL = (window as any).C_URL;
